import { useContext } from 'react';

import { ModuleContext } from './ModuleContextProvider.context';
import { ModuleContextState } from './ModuleContextProvider.types';

export const useModuleContext = <C extends ModuleContextState>(): C => {
  const context = useContext(ModuleContext) as unknown as C | null;
  if (!context) {
    throw new Error('useModuleContext must be used within a ModuleContextProvider');
  }
  return context;
};
